import urls from '@src/configs/web.config';

// 获取智能硬件市场
export const getPrivacyInfo = async () => {
  try {
    const res = await fetch(`${urls.privacyInfo}`, {method: "GET"})
    return res ? res : null;
  } catch (error) {
    return null;
  }
}